import { APP_CHARTS_CONFIG } from '../../types';

const state = () => ({
  chartsConfig: {},
});

export const getters = {
  [APP_CHARTS_CONFIG]({ chartsConfig }) {
    return chartsConfig;
  },
};

export const mutations = {
  [APP_CHARTS_CONFIG](stateObj, chartsConfig) {
    stateObj.chartsConfig = chartsConfig || {};
  },
};

export const actions = {
  [APP_CHARTS_CONFIG]({ commit }, chartsConfig) {
    commit(APP_CHARTS_CONFIG, chartsConfig);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
